var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(-11141 23581)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 125,
    cy: 125,
    r: 125,
    transform: "translate(11141 -23581)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805",
    transform: "translate(10761.338 -24075.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M440.274,551.972s-9.837,7.293-9.666,30.02-2.883,31.374-6.615,39.686-1.527,23.4,2.376,27.644,4.069,13.4,4.069,13.4-15.589-1.379-17.291-6.287,0-40.182,0-40.182-.007-53.254-.007-53.764-.339-10.176,10.176-10.515S440.274,551.972,440.274,551.972Z",
    transform: "translate(6.726 2.045)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M426.817,621.03H409.391a2.275,2.275,0,1,1,0-4.551h17.425a2.275,2.275,0,1,1,0,4.551Z",
    transform: "translate(0 84.511)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M562.784,621.03H437.323a2.275,2.275,0,1,1,0-4.551h125.46a2.275,2.275,0,0,1,0,4.551Z",
    transform: "translate(35.625 84.511)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M441.455,621.03H422.882a2.275,2.275,0,0,1,0-4.551h18.572a2.275,2.275,0,1,1,0,4.551Z",
    transform: "translate(17.207 84.511)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M567.165,602.424c0,5.991-8.44,10.849-18.847,10.849H451.286c-10.41,0-18.847-4.858-18.847-10.849",
    transform: "translate(32.298 66.585)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M557.593,673.674H444.565a13.141,13.141,0,0,1-13.127-13.125V569.976a13.14,13.14,0,0,1,13.127-13.125H557.593a13.138,13.138,0,0,1,13.125,13.125v90.574A13.139,13.139,0,0,1,557.593,673.674ZM444.565,561.4a8.585,8.585,0,0,0-8.576,8.574v90.574a8.585,8.585,0,0,0,8.576,8.574H557.593a8.583,8.583,0,0,0,8.574-8.574V569.976a8.583,8.583,0,0,0-8.574-8.574Z",
    transform: "translate(31.021 8.46)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1207",
    "data-name": "Rectangle 1207",
    width: 89.56,
    height: 4.551,
    transform: "translate(489.159 594.313)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 89.56,
    height: 4.551,
    transform: "translate(489.159 609.576)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1209",
    "data-name": "Rectangle 1209",
    width: 89.56,
    height: 4.551,
    transform: "translate(489.159 624.669)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M503.778,603.556H468.843a5.5,5.5,0,0,1-5.5-5.5V593.99a5.5,5.5,0,0,1,5.5-5.5h34.935a5.5,5.5,0,0,1,5.5,5.5v4.069A5.5,5.5,0,0,1,503.778,603.556Zm-34.935-10.515a.949.949,0,0,0-.947.949v4.069a.946.946,0,0,0,.947.947h34.935a.946.946,0,0,0,.947-.947V593.99a.949.949,0,0,0-.947-.949Z",
    transform: "translate(71.717 48.813)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M449.327,667.041H424.4a13.142,13.142,0,0,1-13.127-13.127V563.343A13.142,13.142,0,0,1,424.4,550.218H537.43v4.551H424.4a8.585,8.585,0,0,0-8.576,8.574v90.571a8.587,8.587,0,0,0,8.576,8.576h24.925Z",
    transform: "translate(5.305)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1210",
    "data-name": "Rectangle 1210",
    width: 10.506,
    height: 4.551,
    transform: "translate(443.279 579.218)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    width: 11.353,
    height: 4.551,
    transform: "translate(443.279 594.482)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 11.353,
    height: 4.551,
    transform: "translate(443.279 609.576)",
    fill: "#2f4265"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.758424bfa8eaf239c2a47d40cbfe43e5.svg";
export { ForwardRef as ReactComponent };